import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";

function Order() {
  const [order, setOrder] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate(); // ✅ use navigate instead of window.location
    const token = localStorage.getItem("token");

    const [filter, setFilter] = useState("today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [report, setReport] = useState(null);
    
  
    const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this order?")) return;

  try {
    const { data } = await apiClient.delete(ADMIN.DELETE_ORDER(id));
    if (!data.success) throw new Error(data.message || "Delete failed");

    toast.success("Order deleted successfully");
    setOrder(order.filter((c) => c._id !== id));
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to delete order");
  }
};

const handleEdit = (orderData) => {
    // Option 1: Navigate with query param
    navigate(`/addorder?id=${orderData._id}`);

    // Option 2: open a modal pre-filled with paymentData
  };

    useEffect(() => {
      const fetchorder= async () => {
        try {
          const { data } = await apiClient.get(ADMIN.GET_ORDER);
          if (data.success) {
            setOrder(data.items);
          }
        } catch (err) {
          console.error("Error fetching order:", err);
          toast.error(err.response?.data?.message || err.message || "Failed to fetch orders");
        } finally {
          setLoading(false);
        }
      };
  
      fetchorder();
    }, []);

  const fetchAndDownloadPDF = async () => {
     try {
       const { data } = await apiClient.get(ADMIN.GET_ORDER);
       if (data.success) {
         setOrder(data.items);
       }
       if (!report) {
         toast.error("No report data available");
         return;
       }

       const doc = new jsPDF();
       doc.text("Sales Report", 14, 20);

       const tableColumn = ["Order ID" ,"Total Amount","Status", "Date"];
       const tableRows = [];

       report.orders.forEach((order) => {
         tableRows.push([
           order._id,
           order.total,
           order.status,
           new Date(order.createdAt).toLocaleString(),
         ]);
       });

       autoTable(doc, {
         head: [tableColumn],
         body: tableRows,
         startY: 30,
       });

       const finalY = doc.lastAutoTable.finalY || 30;
       doc.text(`Total Orders: ${report.report.totalOrders}`, 14, finalY + 10);
       doc.text(`Total Sales: ₹${report.report.totalSales}`, 14, finalY + 20);

       doc.save(`sales_report_${new Date().toISOString().slice(0, 10)}.pdf`);
       toast.success("Sales report downloaded successfully!");
     } catch (err) {
       console.error("Error generating PDF:", err);
       toast.error(err.response?.data?.message || err.message || "Failed to download sales report");
     }
};

useEffect(() => {
  const fetchReportForDisplay = async () => {
    try {
      let url = `${ADMIN.SALES_REPORT}?filter=${filter}`;
      if (filter === "custom" && startDate && endDate) {
        url = `${ADMIN.SALES_REPORT}?startDate=${startDate}&endDate=${endDate}`;
      }

      const { data } = await apiClient.get(url);
      if (data.success) setReport(data);
    } catch (err) {
      console.error("Error fetching report:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch sales report");
    }
  };

  fetchReportForDisplay();
}, [filter, startDate, endDate]);
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title"> Order Table </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li className="breadcrumb-item active" aria-current="page">Order table</li>
            </ol>
          </nav>
        </div>
        <div className='row'>
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row justify-content-between">
                  <div className="col-12 d-flex row">
                    <select className="col-2" onChange={(e) => setFilter(e.target.value)}>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="last7days">Last 7 Days</option>
                      <option value="lastMonth">Last Month</option>
                      <option value="custom">Custom Range</option>
                    </select>

                    {filter === "custom" && (
                      <div className="col-5 d-flex">
                        <input type="date" onChange={(e) => setStartDate(e.target.value)} />
                        <input type="date" onChange={(e) => setEndDate(e.target.value)} />
                      </div>
                    )}
                    <button onClick={fetchAndDownloadPDF} className="btn btn-success col-2">
                      Download PDF
                    </button>
                  </div>

                  {report && (
                  <div className="col-12 row justify-content-end">
                    <div className="col-6 d-flex">
                      <h3 className="px-1">Total Sales: ₹{report.report.totalSales}</h3>
                      <h3 className="px-1">Total Orders: {report.report.totalOrders}</h3>
                    </div>
                    {/* table here */}
                  </div>
                )}
                </div>
                <div className="row">
                  <div className="col-10">
                    <h4 className="card-title">Order Data</h4>
                    
                    <p className="card-description"></p>
                  </div>
                  
                  {/* <div className="col-2">
                    <a href="./addorder">
                      <button className="btn-primary">Add Item</button>
                    </a>
                  </div> */}
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> Serial No </th>
                        <th> Table </th>
                        <th> Customer </th>
                        <th> Type </th>
                        <th> Total </th>
                        <th> Status </th>
                        <th> Actions </th>

                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">Loading...</td>
                        </tr>
                      ) : order.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">No tables found</td>
                        </tr>
                      ) : (
                        order.map((t, index) => (
                          <tr key={t._id}>
                            <td>{index + 1}</td>
                            <td>{t.table_id}</td>
                            <td>{t.customer_id}</td>
                            <td>{t.type}</td>
                            <td>{t.total}</td>
                            <td>{t.status}</td>
                            <td>
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>
                                <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(t._id)}
                              >
                                  Delete</button>

                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Order;
